<template>

    <div class='media' ref='media'>

        <template v-if='type == "svg"'>
            <template v-if='inlineSvg' v-html='inlineSvg' />
            <img v-else
                class='media__obj media__obj--img media__obj--svg'
                :style='style'
                :src='url'
                :alt='alt'
            />
        </template>

        <img v-else-if='type == "image"' 
            class='media__obj media__obj--img'
            :style='style'
            :sizes='boxWidth'
            :src='srcCurrent'
            :srcset='srcsetCurrent'
            :alt='alt'
            :width='width'
            :height='height'
        />

        <video v-else-if='type == "video"'
            class='media__obj media__obj--vid'
            :style='style'
            :preload='inView ? "auto" : "none"'
            muted
            loop
            playsinline>
            <source :src='url' type='video/mp4' />
        </video>
        
    </div>

</template>


<script>
export default {
    name: 'Media',
    props: {
        type: String,
        url: String,
        srcset: String,
        extension: String,
        width: String,
        height: String,
        objFit: String,
        objPosition: String,
        alt: String,
        inlineSvg: String
    },
    data() {
        return {
            inView: false,
            boxWidth: null
        }
    },
    computed: {
        style () {
            return {
                objectPosition: this.objPosition,
                objectFit: this.objFit
            }
        },
        srcCurrent () {
            const placeholderWidth = this.width ?? 1;
            const placeholderHeight = this.height ?? 1;
            const placeholderSrc = `data:image/svg+xml,%3Csvg width='${placeholderWidth}' height='${placeholderHeight}' viewBox='0 0 ${placeholderWidth} ${placeholderHeight}' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Crect style='fill: var(--color)' opacity='0' x='0' y='0' width='${placeholderWidth}' height='${placeholderHeight}'%3E%3C/rect%3E%3C/svg%3E`;

            return this.inView ? this.url : placeholderSrc;
        },
        srcsetCurrent () {
            return this.inView && this.srcset ? this.srcset : null;
        }
    },
    mounted () {
        this.data = {...this.$refs.media.dataset};
        this.observer = new window.IntersectionObserver(this.onIntersect, {
            root: null,
            rootMargin: '200%',
            threshold: 0
        });

        this.observer.observe(this.$refs.media);
    },
    beforeUnmount () {
        this.observer.unobserve(this.$refs.media);
    },
    methods: {
        onIntersect (entries) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.boxWidth = entry.boundingClientRect.width + 'px';
                    this.inView = true;
                    this.observer.unobserve(entry.target);
                }
            });
        }
    }
};
</script>